// Shared asset/accessory utility functions — imported by Assets.js, Accessories.js, Reports.js

export const DEREC_TYPES = ['sold', 'donated', 'scrapped', 'written_off', 'eol'];

// asOfDate defaults to today; pass derecognition_date when calculating WDV at disposal
export function calcWDV(price, purchasedDate, asOfDate = null) {
  if (!price || !purchasedDate) return null;
  const end = asOfDate ? new Date(asOfDate) : new Date();
  const ageYears = (end - new Date(purchasedDate)) / (365.25 * 86400000);
  return Math.max(0, parseFloat(price) * (1 - Math.min(1, ageYears / 4)));
}

export function fmtLKR(v) {
  return v != null ? `LKR ${Math.round(v).toLocaleString()}` : '—';
}

// ── Custody rules — mirrors backend/utils/custody.js ─────────────────────────
// Statuses that mean the item is out of circulation: it holds no employee and
// cannot be allocated. 'in_repair' and 'eol' are excluded on purpose — the
// asset is still charged to its holder while under repair, and an EOL asset is
// usually still in use pending a derecognition decision.
export const ASSET_RELEASE_STATUSES = ['broken', 'lost', 'donated', 'disposed', 'derecognized'];
export const ASSET_BLOCK_ALLOCATION = ['broken', 'lost', 'donated', 'disposed', 'derecognized'];
export const ACCESSORY_RELEASE_STATUSES = ['broken', 'lost', 'donated', 'disposed', 'derecognized'];

export const releasesAssetCustody = s => !!s && ASSET_RELEASE_STATUSES.includes(s);
export const blocksAssetAllocation = s => !!s && ASSET_BLOCK_ALLOCATION.includes(s);
export const releasesAccessoryCustody = s => !!s && ACCESSORY_RELEASE_STATUSES.includes(s);
export const statusLabel = s => String(s || '').replace(/_/g, ' ');
